import AppError from '../errors/AppError';
import api from './api';
import { getToken } from './auth';

interface DetalheSection<T = Record<string, unknown>> {
  nada_consta?: { mensagem: string };
  detalhe?: T;
}

export interface OcorrenciaResumo {
  total_ocorrencias?: number;
  primeira_ocorrencia?: string;
  ultima_ocorrencia?: string;
  vlr_total?: number;
  tipo_anotacao?: string;
  [key: string]: unknown;
}

export interface OcorrenciaDetalhe {
  dt_ocorrencia?: string;
  modalidade?: string;
  origem?: string;
  cidade?: string;
  uf?: string;
  cartorio?: string;
  nome_banco?: string;
  vlr_pendencia?: number;
  vlr_protesto?: number;
  vlr_cheque?: number;
  tipo_anotacao?: string;
  nome_empresa?: string;
  percentual_participacao?: number;
  tipo_documento?: string;
  num_documento?: string;
  [key: string]: unknown;
}

// Blocos de ocorrência (pendencias_internas, pendencias_financeiras, protesto_estadual,
// cheques_sem_fundos, alerta_documentos_roubados, participacao_societaria) retornam
// "resumo" (objeto ou array, a depender do bloco) + "detalhes" (array) quando há ocorrência,
// e "nada_consta" quando não há - nunca "detalhe" no singular.
export interface OcorrenciaSection {
  nada_consta?: { mensagem: string };
  resumo?: OcorrenciaResumo | OcorrenciaResumo[];
  detalhes?: OcorrenciaDetalhe[];
}

interface ConfirmeiDetalhe {
  nome_razao: string;
  dt_origem: string;
  cod_situacao: string;
  situacao_doc: string;
  dt_situacao: string;
  ccf_indisponivel: boolean;
  nome_mae: string;
}

interface ConsultasSemCheques {
  qtd_consultas_15_dias: number;
  qtd_consultas_30_dias: number;
  qtd_consultas_60_dias: number;
  qtd_consultas_90_dias: number;
}

interface SerasaScorePositivoDetalhe {
  pontuacao: number;
  risco: number;
  desc_risco: string;
}

export interface CrednetResponse {
  confirmei: DetalheSection<ConfirmeiDetalhe> | null;
  pendencias_internas: OcorrenciaSection | null;
  pendencias_financeiras: OcorrenciaSection | null;
  protesto_estadual: OcorrenciaSection | null;
  // A SCC retorna o protesto sob "protesto_nacional" em vez de "protesto_estadual"
  // quando o adicional "Anotações Completas" é utilizado.
  protesto_nacional?: OcorrenciaSection | null;
  cheques_sem_fundos: OcorrenciaSection | null;
  alerta_documentos_roubados: OcorrenciaSection | null;
  participacao_societaria: OcorrenciaSection | null;
  consultas_serasa: { consultas_sem_cheques: ConsultasSemCheques } | null;
  serasa_score_positivo: DetalheSection<SerasaScorePositivoDetalhe> | null;
  [key: string]: unknown;
}

async function findClientDebtByCPF(cpf: string): Promise<CrednetResponse> {
  try {
    const response = await api.post<CrednetResponse>(
      '/divida/crednet',
      { cpf },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return response.data;
  } catch (err: any) {
    throw new AppError(err, err.statusCode);
  }
}

export default { findClientDebtByCPF };
